const $ = window.jQuery;

const http = {
  req() {
    // const options = {
    //   method,
    //   headers: {
    //     "Content-Type": "application/json",
    //     // 'Content-Type': 'application/x-www-form-urlencoded',
    //   },
    // }
    // if( method == 'post') {
    //   options.body = JSON.stringify({...data, ...{nonce: wpApiSettings.nonce}})
    // }
    // return await fetch(ajaxurl, options).then(res => res.json())


    // return $.ajax({
    //   url: ajaxurl,
    //   global: false,
    //   type,
    //   data: {...data, ...{nonce: wpApiSettings.nonce}}
    // })

    return axios.create({
      baseURL: ajaxurl,
      responseType: 'json', // default
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
  },
  async post(data) {
    return await this.req().post('', {...data, ...{nonce: wpApiSettings.nonce}});
  }
}

export {
  http,
}